import Enum from "../../../../../../enums/Enum";

const FrequencyEnum = new Enum({
    ONCETWICEADAY: {name: "Once-twice a Day"},
    SEVERALTIMESADAY: {name: "Several Times a Day"},
    ALLDAY: {name: "All day"},
    RANDOM: {name: "Random"}
});

export default FrequencyEnum;